import { render, staticRenderFns } from "./ExpertCarousel.vue?vue&type=template&id=43b0de8b&scoped=true"
import script from "./ExpertCarousel.vue?vue&type=script&lang=js"
export * from "./ExpertCarousel.vue?vue&type=script&lang=js"
import style0 from "./ExpertCarousel.vue?vue&type=style&index=0&id=43b0de8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b0de8b",
  null
  
)

export default component.exports